import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import type { SupporterComment, SupporterCommentPetition } from '../../shared/types';

import { SupporterCommentCardBody } from './components/SupporterCommentCardBody';
import { SupporterCommentCardFooter } from './components/SupporterCommentCardFooter';
import { SupporterCommentCardHeader } from './components/SupporterCommentCardHeader';

export function SupporterCommentCard({
	supporterComment,
	petition,
}: {
	supporterComment: SupporterComment;
	petition: SupporterCommentPetition;
}): React.JSX.Element {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return (
		<Box
			variant="bordered"
			sx={{ borderColor: 'sunrise.semantic.stroke.weaker' }}
			data-testid={`supporter-comment-${supporterComment.id}`}
			p={[16]}
			mb={[24]}
		>
			<Flex
				sx={{
					flexDirection: 'column',
					...(isSunriseThemeEnabled
						? {
								gap: '16px',
							}
						: {
								gap: '10px',
							}),
				}}
			>
				<SupporterCommentCardHeader supporterComment={supporterComment} />

				<SupporterCommentCardBody supporterComment={supporterComment} />

				<SupporterCommentCardFooter supporterComment={supporterComment} petition={petition} />
			</Flex>
		</Box>
	);
}
